import React, { useEffect, useState } from 'react';
import actions from '@flux/action';
import { connect } from 'react-redux';
// import '@style/modules/insights/operatingModel.scss';
// import '@style/modules/insights/operatingModelEdit.scss';
import '../../../styles/modules/insights/operatingModel.scss';
import '../../../styles/modules/insights/operatingModelEdit.scss';

import OperatingModelEdit from '@modules/insights/OperatingModel/OperatingModelEdit';
import OperatingModelView from '@modules/insights/OperatingModel/OperatingModelView';

const OperatingModel = (props) => {
  const { fetchData, operatingModel, projectId } = props;
  const dataIsValid = operatingModel && operatingModel.length > 0;
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const [detailTitle, setDetailTitle] = useState('');
  const [detailBody, setDetailBody] = useState('');

  useEffect(() => {
    fetchData(projectId);
  }, []);

  useEffect(() => {
    if (dataIsValid) {
      setSelectedId(operatingModel[0].id);
      setDetailTitle(operatingModel[0].name);
      setDetailBody(operatingModel[0].activities.map((e) => e.description));
    }
  }, [operatingModel]);

  const onClickHandler = (id) => {
    const selected = operatingModel.find((e) => e.id === id);
    const selectedId = selected.id;
    const detailTitle = selected.name;
    const detailBody = selected.activities.map((e) => e.description);

    setSelectedId(selectedId);
    setDetailTitle(detailTitle);
    setDetailBody(detailBody);
  };
  if (isEditMode) {
    return (
      <OperatingModelEdit
        projectId={projectId}
        setIsEditMode={setIsEditMode}
        operatingModel={operatingModel}
      />
    );
  }
  return (
    <OperatingModelView
      dataIsValid={dataIsValid}
      operatingModel={operatingModel}
      selectedId={selectedId}
      onClickHandler={onClickHandler}
      detailTitle={detailTitle}
      detailBody={detailBody}
      setIsEditMode={setIsEditMode}
    />
  );
};

const mapStateToProps = ({ common, insights, projects, login }) => {
  const projectId = common.currentId;
  const { operatingModel = [] } = insights.insightsData[projectId] || {};
  return {
    operatingModel,
    projectId,
    permission: projects.sectionsPermission.insightPermission,
    userInfo: login.userInfo || {},
  };
};

const mapDispatchToProps = (dispatch) => ({
  async fetchData(params) {
    await dispatch(actions.fetchOperatingModelData(params));
  },
  async changeOrderAndRefetch(insightId, newIndex) {
    await dispatch(actions.changeOrderAndRefetch(insightId, newIndex));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(React.memo(OperatingModel));
